import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import { Modal } from "antd";

/** 阿里巴巴分销标签 */
export const aliOutOrderTags = [
    OrderTag.ALI_OUT_ORDER_TAOBAO,
    OrderTag.ALI_OUT_ORDER_PDD,
    OrderTag.ALI_OUT_ORDER_DY,
    OrderTag.ALI_OUT_ORDER_KWAI,
    OrderTag.ALI_OUT_ORDER_XHS,
    OrderTag.ALI_OUT_ORDER_JD,
    OrderTag.ALI_OUT_ORDER_WEIXIN,
    OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO,
    OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD,
    OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY,
    OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI,
    OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS,
    OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD,
];

/** 是否有阿里分销订单 */
export function isAnyOrderWithAliOutTag(orders: OrderDTO[]) {
    for (const order of orders) {
        if (order.tags?.some((tag) => aliOutOrderTags.includes(tag))) {
            return true;
        }
    }

    return false;
}

type AliOutOrderTag =
    | OrderTag.ALI_OUT_ORDER_TAOBAO
    | OrderTag.ALI_OUT_ORDER_PDD
    | OrderTag.ALI_OUT_ORDER_DY
    | OrderTag.ALI_OUT_ORDER_KWAI
    | OrderTag.ALI_OUT_ORDER_XHS
    | OrderTag.ALI_OUT_ORDER_JD
    | OrderTag.ALI_OUT_ORDER_WEIXIN
    | OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO
    | OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD
    | OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY
    | OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI
    | OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS
    | OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD;

/**
 *  获取订单中阿里分销加密标签
 */
export function getAliOutOrderTagInfo(order: OrderDTO): AliOutOrderTag {
    for (const tag of order.tags || []) {
        switch (tag) {
            case OrderTag.ALI_OUT_ORDER_TAOBAO:
                return OrderTag.ALI_OUT_ORDER_TAOBAO;

            case OrderTag.ALI_OUT_ORDER_PDD:
                return OrderTag.ALI_OUT_ORDER_PDD;

            case OrderTag.ALI_OUT_ORDER_DY:
                return OrderTag.ALI_OUT_ORDER_DY;

            case OrderTag.ALI_OUT_ORDER_KWAI:
                return OrderTag.ALI_OUT_ORDER_KWAI;

            case OrderTag.ALI_OUT_ORDER_XHS:
                return OrderTag.ALI_OUT_ORDER_XHS;

            case OrderTag.ALI_OUT_ORDER_JD:
                return OrderTag.ALI_OUT_ORDER_JD;

            case OrderTag.ALI_OUT_ORDER_WEIXIN:
                return OrderTag.ALI_OUT_ORDER_WEIXIN;

            case OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO:
                return OrderTag.ALI_PLAINTEXT_OUT_ORDER_TAOBAO;

            case OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD:
                return OrderTag.ALI_PLAINTEXT_OUT_ORDER_PDD;

            case OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY:
                return OrderTag.ALI_PLAINTEXT_OUT_ORDER_DY;

            case OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI:
                return OrderTag.ALI_PLAINTEXT_OUT_ORDER_KWAI;

            case OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS:
                return OrderTag.ALI_PLAINTEXT_OUT_ORDER_XHS;

            case OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD:
                return OrderTag.ALI_PLAINTEXT_OUT_ORDER_JD;

            default:
                break;
        }
    }

    return undefined;
}

/** 手工店铺平台加密订单标签 */
export const encryptedManualOrderTags = [
    OrderTag.ENCRYPTED_MANUAL_ORDER_DOUDIAN,
    OrderTag.ENCRYPTED_MANUAL_ORDER_TAOBAO,
    OrderTag.ENCRYPTED_MANUAL_ORDER_PDD,
    OrderTag.ENCRYPTED_MANUAL_ORDER_KWAI,
    OrderTag.ENCRYPTED_MANUAL_ORDER_JD,
    OrderTag.ENCRYPTED_MANUAL_ORDER_XHS,
];

/** ---------------订单包含特殊标签--------------------- */
export function isAnyOrderWithAliCanNotShipTag(orders: OrderDTO[]) {
    return orders?.some((order) => order.tags?.includes(OrderTag.ALI_CAN_NOT_SHIP));
}

export function isAnyOrderWithTbCanNotShipTag(orders: OrderDTO[]) {
    return orders?.some((order) => order.tags?.includes(OrderTag.TAOTIAN_PAID_FORBIN_CONSIGN));
}

export function isAnyOrderWithCanNotShipTag(orders: OrderDTO[]) {
    return orders?.some((order) => order.tags?.includes(OrderTag.CANNOT_SHIP));
}

export function isAnyOrderWithDDSupplierTag(orders: OrderDTO[]) {
    return orders?.some((order) => order.tags?.includes(OrderTag.DOUDIAN_ORDER_SUPPLY));
}

export function isOrderWithEncryptedManualTag(order: OrderDTO) {
    return order?.tags?.some((tag) => encryptedManualOrderTags.includes(tag));
}

export function isAnyOrderWithJdConsolidationTag(order: OrderDTO) {
    return !!order.tags?.includes(OrderTag.JD_CONSOLIDATION_XINJIANG);
}

export function isOrderWithPresentTag(order: OrderDTO) {
    return !!order.tags?.includes(OrderTag.PRESENT);
}

export function isAnyOrderWithJdPurchaseTag(orders: OrderDTO[]) {
    return orders?.some((order) => order.tags?.includes(OrderTag.JD_PURCHASE));
}

export function isAnyOrderWithPreSaleTag(orders: OrderDTO[]) {
    return orders?.some((order) =>
        order.tags?.some((orderTag) => [OrderTag.PRESALE, OrderTag.FULL_PAYMENT_PRESALE].includes(orderTag)),
    );
}

export function isAnyOrderWithTaoTianReissueTag(orders: OrderDTO[]) {
    return orders?.some((order) => order?.tags?.includes(OrderTag.TAOTIAN_REISSUE));
}

export function isAnyOrderWithAliWarehouse(orders: OrderDTO[]) {
    return orders?.some((order) => order?.tags?.includes(OrderTag.ALI_FULFILLMENT_BY_WAREHOUSE));
}

export function isAnyOrderWithPddWarehouse(orders: OrderDTO[]) {
    return orders?.some((order) => order?.tags?.includes(OrderTag.PDD_FULFILLMENT_BY_SHARED_WAREHOUSE));
}

export function isAnyOrderWithJDPetItem(orders: OrderDTO[]) {
    return orders?.some((order) => order?.tags?.includes(OrderTag.JD_PET_ITEM));
}

/** -------------------------------------------------- */

/** ---------------------集运相关----------------------- */

const pddConsolidateOrderTags = [
    OrderTag.PDD_XINJIANG_CONSOLIDATE,
    OrderTag.PDD_HK_CONSOLIDATE,
    OrderTag.PDD_MACAO_CONSOLIDATE,
    OrderTag.PDD_KAZAKHSTAN_CONSOLIDATE,
    OrderTag.PDD_XIZANG_CONSOLIDATE,
    OrderTag.PDD_JAPAN_CONSOLIDATE,
    OrderTag.PDD_TAIWAN_CONSOLIDATE,
    OrderTag.PDD_KOREA_CONSOLIDATE,
    OrderTag.PDD_SINGAPORE_CONSOLIDATE,
    OrderTag.PDD_MALAYSIA_CONSOLIDATE,
    OrderTag.PDD_THAILAND_CONSOLIDATE,
    OrderTag.PDD_VIETNAM_CONSOLIDATE,
    OrderTag.PDD_KYRGYZSTAN_CONSOLIDATE,
    OrderTag.PDD_UZBEKISTAN_CONSOLIDATE,
    OrderTag.PDD_GANSU_CONSOLIDATE,
    OrderTag.PDD_NEIMENGGU_CONSOLIDATE,
    OrderTag.PDD_NINGXIA_CONSOLIDATE,
    OrderTag.PDD_QINGHAI_CONSOLIDATE,
];

export function isPddConsolidateShippingOrder(order: OrderDTO) {
    return order.tags?.some((tag) => pddConsolidateOrderTags.includes(tag));
}

/**
 * 目前仅拼多多集运订单可以合并
 */
function isConsolidatedShippingOrderTag(orderTag: OrderTag) {
    return [
        OrderTag.CONSOLIDATED_SHIPPING,
        OrderTag.TAOTIAN_CONSOLIDATED_SHIPPING,
        OrderTag.DOUDIAN_CONSOLIDATION_XINJIANG,
        OrderTag.DOUDIAN_CONSOLIDATION_XIZANG,
        OrderTag.JD_CONSOLIDATION_XINJIANG,
        OrderTag.TAOTIAN_XINJIANG_CONSOLIDATE,
        OrderTag.KWAI_CONSOLIDATION_XINJIANG,
        OrderTag.KWAI_CONSOLIDATION_NEIMENGGU,
        OrderTag.KWAI_CONSOLIDATION_QINGHAI,
        OrderTag.KWAI_CONSOLIDATION_GANSU,
        OrderTag.KWAI_CONSOLIDATION_NINGXIA,
        OrderTag.KWAI_CONSOLIDATION_XIZANG,
        ...pddConsolidateOrderTags,
    ].includes(orderTag);
}

/**
 * 是否为集运订单
 */
export function isConsolidatedShippingOrder(order: OrderDTO) {
    return order.tags?.some((tag) => isConsolidatedShippingOrderTag(tag));
}

/**
 * 目前仅拼多多集运订单可以合并
 */
function isMergeableConsolidatedShippingOrderTag(orderTag: OrderTag) {
    return pddConsolidateOrderTags.includes(orderTag);
}

/**
 * 当前是否为可以合并的订单，拼多多集运可以合并
 */
export function isMergeableConsolidatedShippingOrder(order: OrderDTO) {
    return order.tags?.some((tag) => isMergeableConsolidatedShippingOrderTag(tag));
}

/** --------------------------------------------------- */

const printShippingDisabledOrderTagTipMap = {
    [OrderTag.ALI_MANAGED_SHIPPING]: "所选订单包含托管订单，由官方仓进行发货履约服务，不支持自己打印发货",
    [OrderTag.ALI_AE_DOOR_PICKUP]:
        "所选订单包含速卖通订单，需要在发货前及时打印和合理张贴揽收单、箱唛和货品标签，请前往商家后台进行操作，不支持自己打印发货",
    [OrderTag.ALI_AE_SELF_SEND]:
        "所选订单包含速卖通订单，需要在发货前及时打印和合理张贴揽收单、箱唛和货品标签，请前往商家后台进行操作，不支持自己打印发货",
    [OrderTag.JD_HYPERLINK_ORDER]: "所选订单包含超链订单，请前往供销店铺后台发货，不支持自己打印发货",
    [OrderTag.JD_HYPERLINK_SUBSIDY_ORDER]: "所选订单包含超链国补订单，请前往供销店铺后台发货，不支持自己打印发货",
};

export function getPrintShippingDisabledTagMsg(orders: OrderDTO[], showModal = true) {
    const printShippingDisabledOrderTags = Object.keys(printShippingDisabledOrderTagTipMap) as OrderTag[];
    const orderTagSet = new Set<OrderTag>();

    for (const order of orders) {
        for (const tag of order.tags || []) {
            orderTagSet.add(tag);
        }
    }

    for (const tag of printShippingDisabledOrderTags) {
        if (!orderTagSet.has(tag)) continue;

        const tip = printShippingDisabledOrderTagTipMap[tag];
        if (showModal && tip) {
            Modal.error({ title: tip });
        }

        return tip;
    }

    return "";
}

/** 不支持自动合并但支持手动合并的标签 */
export const disabledAutoMergeButManualTags = [
    OrderTag.PRESALE,
    OrderTag.FULL_PAYMENT_PRESALE,
    OrderTag.JD_FULFILLMENT,
    OrderTag.JD_DELIVERY,
];
